import type { CustomAppProps, CustomNextPage } from "types/nextCustomType"
import type { IHomeResponse } from "types/services/home-response"

const HomePage: CustomNextPage<CustomAppProps<{ pageData: IHomeResponse }>> = ({
  pageData,
}) => {
  return <div />
}

HomePage.auth = true

export default HomePage
